import { render, staticRenderFns } from "./SocialLogin.vue?vue&type=template&id=351561ec&scoped=true&"
import script from "./SocialLogin.vue?vue&type=script&lang=js&"
export * from "./SocialLogin.vue?vue&type=script&lang=js&"
import style0 from "./SocialLogin.vue?vue&type=style&index=0&id=351561ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351561ec",
  null
  
)

export default component.exports